<!-- <app-page-title [config]="config"></app-page-title> -->

<app-plan-section (clicked)="onPlanClick($event)"></app-plan-section>

<!-- <app-banner-plan [config]="config"></app-banner-plan>

<app-test-table [config]="config"> </app-test-table>

<app-faqs-section [config]="config"> </app-faqs-section> -->
